<template>
  <div class="position-relative" style="z-index: 1037">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-bottom d-block nav-bottom" style="bottom:0px;top: 0;">
        <div class="custom-container-fluid px-0" style="box-shadow: 1px 0px 6px 2px #dfdfdf4f">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="container px-4 py-3 bg-white box-shadow-main popup-scroll" style="height: 100vh">
                <div class="mb-2 pb-1">
                  <img src="../../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" @click="done(false,'close')">
                  <p class="mb-0 body-2-2 text-16 font-bold d-inline-block">{{$t('hotel.filter.filter')}}</p>
                </div>
                <div class="scroll-hide-mobile popup-scroll-body pb-4" style="height: 80vh">
                  <div class="w-100">
                    <div class="row justify-content-center">
                      <div class="col-12">
                        <p class="mb-3 body-2-2 text-15 font-bold">{{$t('hotel.filter.desc')}}</p>
                      </div>
                      <div class="col-6">
                        <!-- <p class="mb-0 body-2-2 font-semibold">Min:</p> -->
                        <div class="w-100 mb-1">
                          <div class="w-16px rounded border-2-green text-center delay mr-1 d-inline-block cursor-pointer align-middle" :class="{'bg-green':is_input.use_min}" @click="toggleInput('use_min', 'toggle')">
                            <img src="../../../assets/img/icon/correct-white.png" class="position-relative" width="10" style="top: -8px">
                          </div>
                          <p class="body-2-1 mb-0 d-inline-block cursor-pointer align-middle" @click="toggleInput('use_min', 'toggle')">Minimun</p>
                        </div>
                        <p v-if="!is_input.min" @click="toggleInput('min',true)" class="mb-0 body-2-2 p-2 font-bold border radius-0" :class="{'cursor-disable bg-custom-light':!is_input.use_min,'text-green':is_input.use_min}">{{formatCurrency(range_price[0],true)}}</p>
                        <input-currency v-model="range_price[0]" v-else @onback-blur="toggleInput('min',false)"></input-currency>
                        <p class="position-absolute mb-0 text-20 font-weight-bold" style="top: 30px;right: -4px;">-</p>
                      </div>
                      <div class="col-6">
                        <!-- <p class="mb-0 body-2-2 font-semibold">Max:</p> -->
                        <div class="w-100 mb-1">
                          <div class="w-16px rounded border-2-green text-center delay mr-1 d-inline-block cursor-pointer align-middle" :class="{'bg-green':is_input.use_max}" @click="toggleInput('use_max', 'toggle')">
                            <img src="../../../assets/img/icon/correct-white.png" class="position-relative" width="10" style="top: -8px">
                          </div>
                          <p class="body-2-1 mb-0 d-inline-block cursor-pointer align-middle" @click="toggleInput('use_max', 'toggle')">Maximum</p>
                        </div>
                        <p 
                          v-if="!is_input.max" 
                          @click="toggleInput('max',true)" 
                          class="mb-0 body-2-2 p-2 font-bold border radius-0"
                          :class="{'cursor-disable bg-custom-light':!is_input.use_max,'text-green':is_input.use_max}">{{formatCurrency(range_price[1],true)}}</p>
                          <input-currency v-model="range_price[1]" v-else @onback-blur="toggleInput('max',false)"></input-currency>
                      </div>
                    </div>
                  </div>
                  <div v-if="show_filter_detail" class="mt-4 pb-1">
                    <p class="mb-3 body-2-2 text-15 font-bold">Advance filter</p>
                    <div class="text-center py-2 rounded-4 ml-2 px-3 d-inline-block bg-green">
                      <p 
                        class="body-2-2 mb-0 text-14 text-white d-inline-block align-middle mr-3">{{detail_filter.data.name}}</p>
                        <img @click="clearFilterDetail" src="../../../assets/img/icon/cancel.png" width="12" class=" d-inline-block align-middle cursor-pointer">
                    </div>
                  </div>
                  <div class="mt-4 pb-1">
                    <p class="mb-3 body-2-2 text-15 font-bold">{{$t('hotel.choose-currency')}}</p>
                    <v-select class="general-select-border body-2-2 text-14 pb-1" :clearable="false"  @input="changeCurrency" :options="currency.list" v-model="currency.selected" label="code">
                      <template #option="{ name, code }">
                        {{name}} ({{code}})
                      </template>
                    </v-select>
                  </div>
                  <div class="mt-4 pb-1">
                    <p class="mb-3 body-2-2 text-15 font-bold">{{$t('hotel.category-rooms')}}</p>
                    <div class="row slim-grid-row cursor-pointer mb-2" v-for="data in category_list" @click="changeCategory(data.id)">
                      <div class="col-10 mb-1">
                        <p class="mb-0 body-2-2 font-regular" v-if="getCurrentLanguage() == 'en'">{{data.name}}</p>
                        <p class="mb-0 body-2-2 font-regular" v-else>{{data.nama}}</p>
                      </div>
                      <div class="col-2">
                        <div class="w-16px rounded-100 border-2-green mt-2px mx-auto">
                          <div class="w-8px rounded-100 position-relative mx-auto mt-2px" :class="{'bg-green':selected_category == data.id}"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-4 pb-1" v-if="showLanguageMenu">
                    <p class="mb-3 body-2-2 text-15 font-bold">{{$t('hotel.choose-language')}}</p>
                    <div class="row slim-grid-row">
                      <div class="col-12 mb-2 rounded-6 cursor-pointer" v-for="list in language" @click="changeLanguage(list.iso_code)">
                        <div class="mb-1">
                          <div class="row slim-grid-row">
                            <div class="col-10">
                              <div class="d-inline-block">
                                <img :src="list.image_url" width="46" class="position-relative align-bottom rounded-3 border" height="30" style="top: -7px">
                              </div>
                              <div class="ml-2 d-inline-block position-relative" style="top: -2px">
                                <p 
                                  class="mb-0 body-2-2 text-14 font-semibold text-truncate" 
                                  :class="{'text-green':language_selected == list.iso_code}">
                                  {{list.name}}</p>
                                <p 
                                  class="mb-0 body-2 text-12 font-regular text-uppercase" 
                                  :class="{'text-green':language_selected == list.iso_code}">
                                  {{list.iso_code}}
                                </p>
                              </div>
                            </div>
                            <div class="col-2">
                              <div class="w-16px rounded-100 border-2-green mt-2 mx-auto">
                                <div class="w-8px rounded-100 position-relative mx-auto mt-2px" :class="{'bg-green':language_selected == list.iso_code}"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <transition name="fade">
                  <template>
                    <div class="position-relative" style="z-index: 1037;">
                      <div class="row no-gutters justify-content-center">
                        <div class="fixed-bottom d-block" style="bottom:0px">
                          <div class="custom-container-fluid px-0">
                            <div class="row justify-content-center no-gutters">
                              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                <div class="container bg-white px-4 py-2">
                                  <div class="row slim-grid-row">
                                    <div class="col-6">
                                      <button type="button" class="button-secondary border-black bg-white text-black box-shadow-none w-100 text-dark" @click="done(true,'done')">{{$t('hotel.reset')}}</button>
                                    </div>
                                    <div class="col-6">
                                      <button type="button" class="button-secondary w-100" @click="done(false,'done')">{{$t('general.apply')}}</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import {formatCurrency,inputCustomOnly} from '@/utils/index.js'
  import currency from "@/data/currency"
  import axios from 'axios';
  import config from '@/config/index.js'
  import flag_united_states from '../../../assets/img/icon/united-states.png'
  import flag_indonesia from '../../../assets/img/icon/indonesia.png'

  export default{
    data(){
      return{
        selected_category: 'room_type',
        range_price: [0,0],
        category_list: [
          {
            id: 'room_type',
            name: 'Rooms Type',
            nama: 'Tipe Kamar'
          },
          {
            id: 'promotion',
            name: 'Promotion',
            nama: 'Promosi'
          },
          {
            id: 'packages',
            name: 'Packages',
            nama: 'Paket'
          }
        ],
        language: this.getMerchant().language,
        language_selected: '',
        currency:{
          list: currency,
          selected: {}
        },
        is_input:{
          min: false,
          max: false,
          use_min: false,
          use_max: false
        },
        error: '',
        base_price: {},
        detail_filter: {
          type: 'room_type',
          data: {}
        }
      }
    },
    mounted(){
      this.selected_category = this.getBeSortBy()
      this.language_selected = this.getCurrentLanguage()
      this.detail_filter = Object.assign({},this.getBeFilterDetail())
      // check price
      let copied_data_price = Object.assign({},this.getBePrice())
      if(this.getBePrice()[0]>0){
        this.range_price[0] = Math.ceil(copied_data_price[0]*this.base_price.a)
        this.is_input.use_min = true
      }
      if(this.getBePrice()[1]>0){
        this.range_price[1] = Math.ceil(copied_data_price[1]*this.base_price.a)
        this.is_input.use_max = true
      }
      // this.range_price = [this.getBePrice()[0]*this.getBaseRate().a,this.getBePrice()[1]*this.getBaseRate().a]
    }, 
    created(){
      this.currency.selected = this.getCurrency()
      this.base_price = this.getBaseRate()
    },
    computed:{
      show_filter_detail(){
        return (Object.keys(this.detail_filter.data).length > 0) ? true:false
      },
      showLanguageMenu(){
        return this.getMerchant().language && this.getMerchant().language.length > 1
      }
    },
    methods:{
      ...mapGetters(['getMerchant','getBePrice','getBeSortBy','getCurrency','getBaseRate','getCurrentLanguage','getBeFilterDetail']),
      ...mapMutations(['setBePrice','setBeSortBy','setCurrency','setBaseRate','setLanguageMutation','setBeFilterDetail']),
      formatCurrency(value,no_base_rate=false){
        return formatCurrency(value,no_base_rate,true,this.currency.selected,this.base_price.b)
      },
      inputNumberDotCommaOnly($event){
        inputCustomOnly('number_dot_comma',$event)
      },
      changeCategory(data){
        this.selected_category = data
      },
      clearFilterDetail(){
        this.detail_filter = {
          type: 'room_type',
          data: {}
        }
      },
      done(reset=false,data=''){
        let timer = 300

        if(reset){
          timer = 600
          this.selected_category = 'room_type'
          this.range_price = [0,0]
          this.setBaseRate({a:1,b:1})
          this.setCurrency(this.getMerchant().base_currency_code)
          this.setBePrice(this.range_price)
          this.setBeSortBy(this.selected_category)
          this.setBeFilterDetail({
            type: 'room_type',
            data: {}
          })
          if (this.getCurrentLanguage() != 'en') {
            this.setLanguageMutation('en')
            window.location.reload()
          }
          let self = this
          setTimeout(()=>{
            self.$emit('done',data)
          },timer)
        }else{
          if(data == 'close'){
            this.$emit('done',data)
          }else{
            this.$convertCurrency(this.currency.selected.code)
            .then(()=>{
              this.setCurrency(this.currency.selected)
              if(this.is_input.use_min && this.range_price[0] == 0){
                this.is_input.use_min = false
              }
              if(!this.is_input.use_min && this.range_price[0] > 0){
                this.range_price[0] = 0
              }
              if(this.is_input.use_max && this.range_price[1] == 0){
                this.is_input.use_max = false
              }
              if(!this.is_input.use_max && this.range_price[1] > 0){
                this.range_price[1] = 0
              }


              let parsing_range_price = [
                this.range_price[0]*this.getBaseRate().b,
                this.range_price[1]*this.getBaseRate().b
              ]
              this.setBePrice(parsing_range_price)
              this.setBeSortBy(this.selected_category)
              // this.rangeSliderSetup()
              this.setBeFilterDetail(this.detail_filter)
              let self = this
              setTimeout(()=>{
                if(self.$hasGoogleTag()){
                  self.$gtag('event', 'search', { method: 'Google' })
                }
                self.$emit('done',data)
              },timer)
            })
            .finally(()=>this.is_load)
          
            if (this.getCurrentLanguage() != this.language_selected) {
              this.setLanguageMutation(this.language_selected)
              window.location.reload()
            }
          }
        }
      },
      changeCurrency(){
        this.$convertCurrency(this.currency.selected.code,false)
        .then(res=>{
          this.range_price = [this.range_price[0]*this.base_price.b,this.range_price[1]*this.base_price.b]
          this.base_price = res
          this.range_price = [Math.ceil(this.range_price[0]*this.base_price.a),Math.ceil(this.range_price[1]*this.base_price.a)]
          
          this.setCurrency(data)
          this.toggleDetail()
        })
      },
      changeLanguage(data){
        this.language_selected = data
      },
      toggleInput(id,data){
        if(id != 'use_min' && id != 'use_max'){
          if((id=='min' && data && this.is_input.use_min) || (id=='max' && data && this.is_input.use_max)){
            this.is_input[id] = data
            let self = this
            // this.$nextTick(() => {
            //   self.$refs[id].focus()
            //   self.$refs[id].select()
            // })
          }
          if(!data){
            var regex_first_zero = /^(?:[1-9][0-9]*|0)$/;
            var regex_number_comma_dot = /^[0-9.,]+$/;
            let index = id == 'min' ? 0:1
            if(regex_number_comma_dot.test(this.range_price[index]) == false){
              this.range_price[index] = 0
            }else if(regex_first_zero.test(this.range_price[index]) == false){
              this.range_price[index] = +this.range_price[index]
            }
            this.is_input[id] = data
          }
        }else{
          this.is_input[id] = !this.is_input[id]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/BeFilterMobile.vue